export class Feedback {
  id: number;
  name: string;
}
